function GolfFitness() {
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <iframe
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQWeLMSo9Pokd8kJXqlCKZaetn9hvVBvf7aHRy8k3DlewOzlSGcmWCWmgLU1trXxPMqgavpDVO_eMTx/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"
        width="100%"
        height="100%"
        title="Google Doc"
      ></iframe>

    </div>
  );
}
export default GolfFitness;


